import styled, { css } from 'styled-components';

interface Props {
  noBorder?: boolean;
}

export const TableRowHeader = styled.th<Props>`
  text-align: left;
  font-weight: 400;
  padding: 16px 0;
  vertical-align: text-top;
  line-height: 24px;

  border-bottom: ${({ noBorder }) =>
    noBorder ? 'none' : '1px solid var(--p-color-stroke-subtle-0)'};

  ${({ noBorder }) =>
    noBorder &&
    css`
      padding-bottom: 0;
    `}
`;
